/**
 * Bar, block and bullet glyphs a pasted quote or a streaming cursor leaves in
 * text ("▎ Most bid stacks…", "…answer▌"). Never part of a title.
 */
const GLYPHS = /[▌▍▎▏█▐│┃]/gu;

/**
 * A thread title as one clean line: quote bars and cursor glyphs removed from
 * every line (not just the first), whitespace and line breaks collapsed.
 */
export function cleanThreadTitle(title: string | null | undefined): string {
  return (title ?? '')
    .replace(GLYPHS, ' ')
    .replace(/^[\s>•·―—–*+-]+/u, '')
    .replace(/\s+/g, ' ')
    .trim();
}
